export default {
  list() {
    return axios.get('/dashboard/mobile-hero-settings')
  },

  create(payload) {
    return axios.post('/dashboard/mobile-hero-settings', payload)
  },

  get(id) {
    return axios.get(`/dashboard/mobile-hero-settings/${id}`)
  },

  update(payload) {
    return axios.put(`/dashboard/mobile-hero-settings/${payload.id}`, payload)
  },

  delete(id) {
    return axios.delete(`/dashboard/mobile-hero-settings/${id}`)
  }
}
